// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformStatuses = {
  online: "Online",
  degraded: "Degraded",
  offline: "Offline",
  queued: "Queued",
  stopped: "Stopped",
  unknown: "Unknown",
  unintegrated: "Not integrated",
  reachable: "Reachable",
} as const;
